export default __webpack_public_path__ + "static/media/bath.ad6d1d96.svg";